import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPropertyId = (state) => {
  const match = get(state, 'router.location.pathname', '').match(/\/properties\/([0-9]*)/);
  return match ? match[1] : null;
};

export const getPropertyLocation = (state) => get(state, 'property.property.regionFullName');

export const getProperty = (state) => get(state, 'property.property');
export const getIsLoading = (state) => !!get(state, 'property.isLoading');
export const getError = (state) => get(state, 'property.error');
export const getTripAdvisorRating = createSelector(getProperty, (property) =>
  (property?.customerRatings || []).find((rating) => rating.source === 'trip_advisor'),
);

export const getRoomTypesWithoutOffers = (state) => get(state, 'property.property.roomTypes');
export const getCountry = createSelector(getProperty, (property) => property?.address?.country);

export const getIsDomestic = createSelector(getCountry, (country) => country === 'Australia');
